import SanityImage from "gatsby-plugin-sanity-image";
import * as React from "react";
import { PropsWithChildren, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { calendar_svg, email_svg, location_svg, mobile_svg, point_svg, whatsapp_svg } from "../../assets/mix_elements";
import { ILink, Image, Maybe } from "../../types/thecookies";
import { has_address, has_country, has_phone, has_time } from "../shared/utils/checkInputs";
import { getLink } from "../shared/utils/getLink";

export type ICustomItem = {
  // si recibe link ignora el name
  icon?: Image | ReactNode;
  link?: Maybe<ILink>;
  name?: string;
};

type PropsCustomItem = PropsWithChildren<{
  data: ICustomItem;
  settings?: { isWithOutIcons?: boolean };
}>;

const CustomItem: React.FC<PropsCustomItem> = (props: PropsCustomItem) => {
  const { t } = useTranslation("global");
  const item = props.data;
  const getSvgIcon = (item: ICustomItem): ReactNode => {
    if (item.icon) return item.icon as ReactNode;
    if (item.link) {
      if (typeof item.link.slug === "string") {
        const slugWithAction = getLink(item.link.slug);
        if (slugWithAction.includes("mailto")) return email_svg;

        if (slugWithAction.includes("tel:")) return mobile_svg;

        if (slugWithAction.includes("https://wa.me")) return whatsapp_svg;
      }
    }
    if (item.name) {
      if (has_time(item?.name)) {
        return calendar_svg;
      }
      if (has_address(item?.name)) {
        return location_svg;
      }
      if (has_phone(item?.name)) {
        return mobile_svg;
      }
      if (has_country(item?.name)) {
        return location_svg;
      }
    }
  };

  return (
    <li className={`m-custom-item`}>
      {!props.settings?.isWithOutIcons && (
        <div className="custom-item__c-icon">
          {item.icon && item.icon instanceof Image ? (
            <SanityImage className="custom-item__icon" {...(item.icon as Image)} width={50} alt={`icon`} />
          ) : (
            getSvgIcon(item)
          )}
        </div>
      )}
      {item.link?.slug && (
        <a className="custom-item__text" href={getLink(item.link.slug)} target="_blank" rel="noreferrer">
          {item.link.name}
        </a>
      )}
      {!item.link && item?.name && <p className="custom-item__text">{item.name}</p>}
    </li>
  );
};

export default CustomItem;
